import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-terms-conditions-privacy',
  templateUrl: './dialog-terms-conditions-privacy.component.html',
  styleUrls: ['./dialog-terms-conditions-privacy.component.scss']
})
export class DialogTermsConditionsPrivacyComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainerRef: ElementRef;

  safeHtml: SafeHtml;
  title: string;
  scrollProgress = 0;
  hasScrolledToBottom = false;

  constructor(  public dialogRef: MatDialogRef<DialogTermsConditionsPrivacyComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.title = this.data?.title || 'Información';
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data?.content || '');
  }

  onScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const total = el.scrollHeight - el.clientHeight;
    this.scrollProgress = total > 0 ? Math.min(100, (el.scrollTop / total) * 100) : 100;
    this.hasScrolledToBottom = this.scrollProgress >= 90;
  }

  get scrollProgressInt(): number {
    return Math.round(this.scrollProgress);
  }

  /* ── Lógica original sin cambios ── */
  close() {
    this.dialogRef.close();
  }

  accept() { this.dialogRef.close(true); }

}
